export class User {
    id: string;
    username: string;
    password: string;
    oldPassword: string;
    confirmPassword: string;
    newPassword: string;
    firstName: string;
    surname: string;
    token: string;
    email: string;
    emailConfirmed: boolean;
    roles: string[];
    loggedin: boolean;

    constructor(data?: any) {
        if (data) {
            this.id = data.id;
            this.username = data.Email;
            this.firstName = data.FirstName;
            this.surname = data.Surname;
            this.email = data.Email;
            this.emailConfirmed = data.EmailConfirmed;
            this.roles = data.Roles;
        }
        else {
            this.id = "";
            this.username = "";
            this.password = "";
            this.confirmPassword = "";
            this.newPassword = "";
            this.firstName = "";
            this.surname = "";
            this.token = "";
            this.email = "";
            this.emailConfirmed = false;
            this.roles = [];
        }
    }
}



// WEBPACK FOOTER //
// E:/Release/InzuzoA/InzuzoA/src/app/_models/user.ts